var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('FullCalendar',{attrs:{"defaultView":"dayGridMonth","showNonCurrentDates":false,"plugins":_vm.calendarPlugins,"header":{
          left: '',
          center: 'title',
          right: 'prev,next'
        },"events":_vm.calendar_events},on:{"eventClick":_vm.eventClick,"dateClick":_vm.dateClick}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }